import React from 'react';
import PropTypes from 'prop-types';
import { kebabCase } from 'lodash';
import { NavItem, NavLink } from 'reactstrap';
import Icon from '../common/containers/icon';
const MainMenuItem = ({
  onClick: _onClick = () => {},
  href: _href = '#',
  glyph: _glyph = '',
  className: _className = '',
  style: _style = {
    textAlign: 'center'
  },
  title,
  active: _active = false
}) => /*#__PURE__*/React.createElement(NavItem, {
  className: _className.length > 0 ? kebabCase(_className) : kebabCase(`mdi-${title}`),
  style: _style,
  onClick: _onClick
}, /*#__PURE__*/React.createElement(NavLink, {
  href: _href,
  active: _active
}, _glyph.length > 0 ? /*#__PURE__*/React.createElement(Icon, {
  glyph: _glyph
}) : null, _glyph.length > 0 && /*#__PURE__*/React.createElement("br", null), title));
MainMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  className: PropTypes.string,
  glyph: PropTypes.string,
  href: PropTypes.string,
  style: PropTypes.shape({}),
  onClick: PropTypes.func,
  active: PropTypes.bool
};
export default MainMenuItem;